import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogRef } from '../../../../services/modal.service';
import {
  ARConsoleFormatType,
  ARConsoleType,
  ARFertilizerType,
} from '../../../../models/agrorendement-common-lists.model';
import { GCOrderItemConsole, GCParcel } from '../../../../models/agrorendement-genconsole.model';
import { toNumber } from '../../../../utils/utils';
import { ARFertilizerEditComponent } from '../common/fertilizer-edit.component';
import { ARVraEditComponent } from '../common/vra-edit.component';
import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { FormsModule } from '@angular/forms';

export class GenconsoleSelectConsoleDialogContext {
  consoles: Array<GCOrderItemConsole>;
  parcel: GCParcel;
  showClose?: boolean;
  isBlocking?: boolean;
  size?: string;
}

@Component({
  standalone: true,
  selector: 'gc-selectconsole-dlg',
  templateUrl: 'genconsole.selectconsole-dialog.component.html',
  imports: [CommonModule, ARVraEditComponent, ARFertilizerEditComponent, TranslatePipe, FormsModule],
})
export class GenconsoleSelectConsoleDialogComponent implements OnInit, AfterViewInit {
  dialog: DialogRef<GenconsoleSelectConsoleDialogContext>;
  get context() {
    return this.dialog?.context;
  }

  console: GCOrderItemConsole;
  originalConsoles: Array<GCOrderItemConsole> = [];

  isValid: boolean = false;

  @ViewChild('consoleEdit') consoleEditor: ARVraEditComponent;
  @ViewChild('fertilizerEdit') fertilizerEditor: ARFertilizerEditComponent;

  constructor(private _elementRef: ElementRef) {}

  ngOnInit() {
    // recopier : console sera utilise pour l'edition
    // dans l'autre sens quand sauve
    if (this.dialog?.context?.consoles) {
      this.originalConsoles = this.originalConsoles.concat(this.dialog.context.consoles);
    } else {
      return;
    }
    this.console = new GCOrderItemConsole();
    this.console.consoleFormatType = Object.assign({}, this.originalConsoles[0].consoleFormatType);
    this.console.consoleModulationType = Object.assign({}, this.originalConsoles[0].consoleModulationType);
    this.console.consoleType = Object.assign({}, this.originalConsoles[0].consoleType);
    this.console.consoleVersion = Object.assign({}, this.originalConsoles[0].consoleVersion);
    this.console.orderItemId = this.originalConsoles[0].orderItemId;
    this.console.otherConsoleVersion = this.originalConsoles[0].otherConsoleVersion;
    this.console.fertilizerType = Object.assign({}, this.originalConsoles[0].fertilizerType);
    this.console.fertilizerConcentration = this.originalConsoles[0].fertilizerConcentration;
  }

  computeValid() {
    this.isValid =
      this.console.consoleFormatType &&
      !!this.console.consoleFormatType.id &&
      this.console.consoleType &&
      !!this.console.consoleType.id &&
      this.console.consoleVersion &&
      !!this.console.consoleVersion.id &&
      this.console.fertilizerType &&
      !!this.console.fertilizerType.id &&
      !!toNumber(this.console.fertilizerConcentration);
  }

  ngAfterViewInit() {}

  close() {
    this.dialog.close();
  }

  save() {
    // TODO changer le traitement des formulaires pour que tout l'objet soit mis
    // a jour, pas juste l'ID
    // le traitement a l'ecran suivant a besoin du code et du label
    // alors que seul l'ID  est change par ar-vra-edit
    // Base sur l'ID, on remplace les objets avec tous les bons
    // attributs
    let tFormatType: ARConsoleFormatType = null;
    for (const formatType of this.consoleEditor.consoleFormatTypes) {
      if (formatType.id == this.console.consoleFormatType.id) {
        tFormatType = formatType;
        break;
      }
    }
    const version = this.consoleEditor.consoleVersionsIndex.get(+this.console.consoleVersion.id);
    let tConsoleType: ARConsoleType = null;
    for (const consoleType of this.consoleEditor.consoleTypes) {
      if (consoleType.id == this.console.consoleType.id) {
        tConsoleType = consoleType;
        break;
      }
    }
    let tFertilizerType: ARFertilizerType = null;
    for (const fertilizerType of this.fertilizerEditor.fertilizerTypes) {
      if (fertilizerType.id == this.console.fertilizerType.id) {
        tFertilizerType = fertilizerType;
        break;
      }
    }

    this.originalConsoles.forEach((x: GCOrderItemConsole) => {
      x.consoleFormatType = tFormatType;
      x.consoleType = tConsoleType;
      x.consoleVersion = version;
      x.orderItemId = x.orderItemId;
      x.otherConsoleVersion = this.console.otherConsoleVersion;
      x.fertilizerType = tFertilizerType;
      x.fertilizerConcentration = toNumber(this.console.fertilizerConcentration);
    });
    this.dialog.close();
  }
}
